package one.healthium.med.presentation.navigation.root

import com.arkivanov.decompose.router.slot.ChildSlot
import com.arkivanov.decompose.router.stack.ChildStack
import com.arkivanov.decompose.router.webhistory.WebNavigationOwner
import com.arkivanov.decompose.value.Value
import com.arkivanov.essenty.backhandler.BackHandlerOwner
import one.healthium.login.navigation.login.SignInComponent
import one.healthium.login.navigation.magic_link.MagicLinkComponent
import one.healthium.login.navigation.silent_login.SilentLoginComponent
import one.healthium.med.AppLaunchState
import one.healthium.med.presentation.navigation.main.MainComponent
import one.healthium.onboarding.navigation.OnboardingComponent
import one.healthium.uscreen.navigation.UScreenComponent
import one.healthium.paywall.navigation.PaywallComponent
import one.primehealth.app.DeepLink

interface RootComponent : BackHandlerOwner, WebNavigationOwner {
    val stack: Value<ChildStack<*, Child>>
    val slot: Value<ChildSlot<*, Child>>

    fun onBackClicked()
    fun onDeepLink(deepLink: String)
    fun onDeepLink(deepLink: DeepLink)
    fun onRefreshStack(appLaunchState: AppLaunchState)

    sealed class Child {
        class Onboarding(val component: OnboardingComponent) : Child()
        class UScreen(val component: UScreenComponent) : Child()
        class SignIn(val component: SignInComponent) : Child()
        class Main(val component: MainComponent) : Child()
        class Paywall(val component: PaywallComponent) : Child()
        class SilentLogin(val component: SilentLoginComponent) : Child()
        class MagicLink(val component: MagicLinkComponent) : Child()
    }
}